
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      var FirstPropertyName = "";
var FirstName = "";
var LastName = "";
var Email = "";
var FirstNameChar = "";
var LastNameChar = "";
var loginobject = "";
var today = new Date();
var PropertiesList1;
var MyDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js";
export default {
  data: function () {
    return {
      PropertiesList: {},
      FirstPropertyName: {},
      FirstName: {},
      LastName: {},
      Email: {},
      FirstNameChar: {},
      LastNameChar: {},
      loginobject: {},
      hideClass: ""
    };
  },
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert("Hello World");
    },
    LoginasProperty: function (propertyid, propertyname, userID) {
      var accordion = app.f7.accordion.toggle('.accordion-item');
      var panellEFT = app.f7.panel.get('.panel-left');
      panellEFT.close();
      $$(".link.icon-only.panel-open").addClass('cant-touch-this');
      const UserSpecificApiKey = this.PropertiesList?.find(property => property.PropertyName == propertyname)?.UserSpecificApiKey;
      var $ = this.$;
      var self = this;
      setTimeout(async function () {
        await actions.LoginAsProperty(propertyid, propertyname, userID, UserSpecificApiKey);

        try {
          await self.$setState({
            FirstPropertyName: propertyname
          });
          app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
            reloadCurrent: true
          });
          $$(".open-side-options-class").removeClass('cant-touch-this');
        } catch (exception) {}
      }, 1500);
    }
  },
  on: {
    pageBeforeOut: async () => {},
    pageBeforeIn: async () => {
      var panel = app.f7.panel.create({
        el: '.panel-left',
        on: {
          opened: function () {}
        }
      });

      if (localStorage.getItem("islogin") == null) {
        app.f7.views.main.router.navigate("/login/", {
          transition: "f7-dive"
        });
      }

      window.onhashchange = function (e) {};
    },
    pageInit: async function (e, page) {
      document.getElementById('planLi').style.display = 'block';
      document.getElementById('availabilityLi').style.display = 'block';
      document.getElementById('reservLi').style.display = 'block';
      document.getElementById('calendarLi').style.display = 'block';
      var $ = this.$;
      var self = this;
      const login = actions.LoginGetResult();
      self.$setState({
        loginobject: login
      }); // if (commEl) {
      //   document.getElementById('communicatorLi').style.display = 'block';
      // }

      let commEl = document.getElementById('communicatorLi');

      if (login?.IsHousekeeper) {
        document.getElementById('planLi').style.display = 'none';
        document.getElementById('availabilityLi').style.display = 'none';

        if (commEl) {
          commEl.style.display = 'none';
        }

        document.getElementById('reservLi').style.display = 'none';
      }

      if (localStorage.getItem("islogin") == null) {
        app.f7.views.main.router.navigate("/login/", {
          transition: "f7-dive"
        });
      }

      const hideClass = login?.IsHousekeeper ? "hide-me" : "";
      self.$setState({
        hideClass: hideClass
      });
      const UserSpecificApiKey = login?.PropertiesList?.find(property => property.PropertyName == login?.PropertyName)?.UserSpecificApiKey;
      var id = login?.PropertyID;
      UserSpecificApiKey;
      var obj = {
        PropertyID: id,
        Date: MyDate,
        UserID: login?.UserID,
        UserSpecificApiKey: UserSpecificApiKey
      };
      app.f7.preloader.show();
      await actions.GetDashboardData(obj, false);
      app.f7.preloader.hide();
      FirstPropertyName = actions.GetPropertyName();
      FirstName = login?.FirstName;
      LastName = login?.LastName;
      Email = login?.Email;
      FirstNameChar = login?.FirstName.substring(0, 1);
      LastNameChar = login?.LastName.substring(0, 1);
      self.$setState({
        PropertiesList: login?.PropertiesList,
        FirstPropertyName: FirstPropertyName,
        FirstName: FirstName,
        LastName: LastName,
        Email: Email,
        FirstNameChar: FirstNameChar,
        LastNameChar: LastNameChar
      });
      document.getElementById('dashboardLink').addEventListener('click', function () {
        let login = JSON.parse(localStorage.getItem("loginJson"));

        if (login.IsHousekeeper) {
          app.f7.views.main.router.navigate('/dashboardKeeper/', {
            transition: 'f7-dive'
          });
        } else {
          app.f7.views.main.router.navigate('/main/', {
            transition: 'f7-dive'
          });
        }

        var panellEFT = app.f7.panel.get('.panel-left');
        panellEFT.close();
      });
    },
    tabAfterIn: async () => {},
    tabInit: async () => {
      $$('#reservationstab').on('click', async () => {
        //app.f7.preloader.show();
        // wait for 3 seconds
        await new Promise(resolve => setTimeout(resolve, 3000));
        app.f7.views.main.router.navigate('/main/reservations/', {
          transition: 'f7-dive'
        });
      });
      var searchbar1 = app.f7.searchbar.create({
        el: ".searchbar-tab1",
        foundEl: ".searchbar-found-tab1",
        notFoudEl: ".searchbar-not-found-tab1",
        searchContainer: ".searchbar-found-tab1",
        searchIn: ".item-title",
        on: {
          enable: function () {
            console.log("Searchbar enabled");
          },
          on: {
            close: function (c) {}
          }
        }
      });
      $$("#English").on("click", function () {
        const newLanguage = "en-US";
        localStorage.setItem("language", newLanguage);
        moment.locale(newLanguage);
        changeLocale(newLanguage);
        app.f7.views.main.router.refreshPage();
      });
      $$("#Greek").on("click", function () {
        const newLanguage = "el-GR";
        localStorage.setItem("language", newLanguage);
        changeLocale(newLanguage);
        moment.locale(newLanguage);
        app.f7.views.main.router.refreshPage();
      });
    }
  },
  id: '0a736c741f',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page><!-- Left panel with cover effect--><div class="panel panel-left"><div class=view><div class="page pagemenu"><div class=page-content><div class=header><div class="" style="height: 100%"><div class="UserInitIm2 MainRTGuestDetailsBC">';
      r += c(ctx_1.FirstNameChar, ctx_1);
      r += ' ';
      r += c(ctx_1.LastNameChar, ctx_1);
      r += '</div><!-- <div class="circle">\n                   <span class="">\n                     ';
      r += c(ctx_1.FirstNameChar, ctx_1);
      r += c(ctx_1.LastNameChar, ctx_1);
      r += '\n                   </span> \n\n                </div> --><!-- <a  href="/settings/" class="item-link material-icons  panel-close setticon">\n                  settings\n                </a> --><div style="padding-top: 0.5rem"><div class=whtxt>';
      r += c(ctx_1.FirstName, ctx_1);
      r += ' ';
      r += c(ctx_1.LastName, ctx_1);
      r += '</div><div class=whtxt>';
      r += c(ctx_1.Email, ctx_1);
      r += '</div></div></div></div><div class="list accordion-list searchbar-found"><ul><li class=accordion-item><a href=# class="item-content item-link"><div class=item-inner><div class=item-title><span class="material-icons homeicon">home </span>';
      r += c(ctx_1.FirstPropertyName, ctx_1);
      r += '</div></div></a><div class=accordion-item-content><div class=block><form class="searchbar searchbar-tab1"><div class=searchbar-inner><div class=searchbar-input-wrap><input type=search placeholder=Search> <i class=searchbar-icon></i> <span class=input-clear-button></span></div><span class=searchbar-disable-button>Cancel</span></div></form><div class="list searchbar-found-tab1"><ul>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.PropertiesList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li class=item-content><a href=# class="item-content item-link panel-close loginsasproperty" @click="LoginasProperty(';
          r += c(ctx_2.PropertyID, ctx_2);
          r += ',\'';
          r += c(ctx_2.PropertyName, ctx_2);
          r += '\', ';
          r += c(ctx_2.UserID, ctx_2);
          r += ');" class=loginproperty><div class=item-inner><div class=item-title style="overflow: unset;\n                                    white-space: break-spaces;">';
          r += c(ctx_2.PropertyName, ctx_2);
          r += '</div></div></a></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div><!-- This list will be visible when there is not any search results --><div class="list simple-list searchbar-not-found searchbar-not-found-tab1"><ul><li>Nothing found</li></ul></div></div></div></li></ul></div><div class=list><ul><li><a href=javascript:void(0) class="item-content item-link panel-close" id=dashboardLink><div class=item-inner><div class=item-title>Dashboard</div></div></a></li><li id=calendarLi style="display: none;"><a href=/main/NewCalendar/ class="item-content item-link panel-close"><div class=item-inner><div class=item-title>';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></a></li><!--                 \n                <li>\n                  <a href="/main/reservations/" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">Reservations</div>\n                    </div>\n                  </a>\n                </li> --><li id=reservLi style="display: none;"><a href=/main/reservations/ class="item-content item-link panel-close"><div class=item-inner><div class=item-title>';
      r += Template7Helpers.t.call(ctx_1, 'reservations', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></a></li><!-- <li>\n                  <a href="#" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">';
      r += Template7Helpers.t.call(ctx_1, 'Calendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\n                    </div>\n                  </a>\n                </li> --><!-- <li>\n                  <a href="#" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">Housekeeping</div>\n                    </div>\n                  </a>\n                </li> --><li id=availabilityLi style="display: none;">';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginobject?.DisableAvailabilities, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=/main/availabilities/ class="item-content item-link panel-close"><div class=item-inner><div class=item-title>Availability - Rates</div></div></a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a class="item-content item-link panel-close" style="pointer-events: none;opacity:0.5;"><div class=item-inner><div class=item-title>Availability - Rates</div></div></a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</li>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.loginobject?.Communicator, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li id=communicatorLi><a href=/communicator/ class="item-content item-link panel-close"><div class=item-inner><div class=item-title>Communicator</div></div></a></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<li><a href=/settings/ class="item-content item-link panel-close"><div class=item-inner><div class=item-title>Settings</div></div></a></li><li id=planLi style="display: none;"><a href=/invoices/ class="item-content item-link panel-close"><div class=item-inner><div class=item-title>Recent Folios</div></div></a></li><!-- \n                <li>\n                  <a\n                    href="/NewCalendar/"\n                    class="item-content item-link panel-close"\n                  >\n                    <div class="item-inner">\n                      <div class="item-title">New Calendar</div>\n                    </div>\n                  </a>\n                </li> --><!-- <li>\n                  <a href="#" id="logoutbtn" class="item-content item-link">\n                    <span class="material-icons icons">\n                      power_settings_new\n                    </span>\n                    <div class="item-inner">\n                      <div class="item-title">Logout</div>\n                    </div>\n                  </a>\n                </li> --><!-- <li>\n                  <a href="#" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">Intelligent</div>\n                    </div>\n                  </a>\n                </li> --><!-- <li>\n                  <a href="#" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">More</div>\n                    </div>\n                  </a>\n                </li>\n                <li>\n                  <a href="https://helpdesk-pms.abouthotelier.com/" class="link external item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">Help Desk</div>\n                    </div>\n                  </a>\n                </li> --><!-- <li>\n                  <a href="#" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">Offers</div>\n                    </div>\n                  </a>\n                </li>\n                <li>\n                  <a href="#" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">Information</div>\n                    </div>\n                  </a>\n                </li>\n                <li>\n                  <a href="#" id="logoutbtn" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">Logout </div>\n                    </div>\n                  </a>\n                </li> --><!-- <li>\n                  <a href="#" id="English" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">---En---</div>\n                    </div>\n                  </a>\n                </li>\n                <li>\n                  <a href="#" id="Greek" class="item-content item-link panel-close">\n                    <div class="item-inner">\n                      <div class="item-title">---Gr---</div>\n                    </div>\n                  </a>\n                </li> --></ul></div><div class=footer><img class=logoclass src=./static/images/logo_roomrack-final-B.png></div></div></div></div></div><div class="fab fab-center-bottom color-blue ';
      r += c(ctx_1.hideClass, ctx_1);
      r += '">';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginobject?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=/new-reservation-home/ ><!-- <a href="/new-reservation-form/"> --> <i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a style="pointer-events: none;opacity:0.5;"><i class="icon f7-icons if-not-md">add</i> <i class="icon material-icons md-only">add</i> </a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="toolbar tabbar toolbar-bottom ';
      r += c(ctx_1.hideClass, ctx_1);
      r += '"><div class="toolbar-inner DashboardToolBar"><a href=./ class=tab-link data-route-tab-id=dashboard><i class=material-icons>dashboard </i><span class=tabbar-label>Dashboard</span> </a><!-- <a\n          href="./reservationscalendar/"\n          class="tab-link"\n          data-route-tab-id="reservationscalendar"\n        >\n          <i class="material-icons"> date_range </i>\n          <span class="tabbar-label">';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span>\n        </a> --> <a href=./NewCalendar/ class=tab-link data-route-tab-id=reservationscalendar><i class=material-icons>date_range </i><span class=tabbar-label>';
      r += Template7Helpers.t.call(ctx_1, 'reservationsCalendar', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> </a><a href="" class=tab-link data-route-tab-id=""><!-- <i class="icon f7-icons if-not-md">email_fill</i>\n                  <i class="icon material-icons md-only">email</i> --> <span class=tabbar-label></span> </a><a href=./reservations/ class=tab-link data-route-tab-id=reservations><!-- <i class="icon f7-icons if-not-md">email_fill</i>\n                <i class="icon material-icons md-only">email</i> --> <i class=material-icons>list </i><span class=tabbar-label>';
      r += Template7Helpers.t.call(ctx_1, 'reservations', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> </a>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginobject?.DisableAvailabilities, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a href=./availabilities/ class=tab-link data-route-tab-id=availabilities><i class=material-icons>date_range </i><span class=tabbar-label>';
          r += Template7Helpers.t.call(ctx_2, 'availability', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span> </a>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a style="pointer-events: none;opacity:0.5;" class=tab-link><i class=material-icons>date_range </i><span class=tabbar-label>Availability</span> </a>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class="tabs tabs-routable"><div class="tab page-content" id=dashboard></div><div class="tab page-content" id=reservations></div><div class="tab page-content" id=addbtn></div><div class="tab page-content" id=availabilities></div><div class="tab page-content" id=activities></div><div class="tab page-content" id=reservationscalendar></div></div></div><style>.hide-me {\n      display: none !important;\n    }\n\n    .cant-touch-this {\n      pointer-events: none;\n    }\n\n    .UserInitIm2 {\n      width: 4rem;\n      height: 4rem;\n      top: calc(48% - 2rem);\n      border-radius: 50%;\n      background: white;\n      font-size: 30px;\n      color: black;\n      text-align: center;\n      line-height: 4rem;\n      text-transform: uppercase;\n\n      position: relative;\n      left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));\n      margin-bottom: 60px;\n    }\n\n    .header {\n      background-color: #4971d9;\n      height: 180px;\n    }\n\n    .whtxt {\n      color: white;\n      position: relative;\n      margin-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));\n    }\n\n    .setticon {\n      position: absolute;\n      top: 52px;\n      /* right: 6px; */\n      color: white;\n      right: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));\n    }\n\n    .logoclass {\n      height: 2rem;\n      width: auto;\n      padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));\n      margin-top: 20px;\n    }\n\n    .list .accordion-item-toggle .item-inner:before,\n    .list:not(.media-list) .accordion-item:not(.media-item) .accordion-item-toggle .item-inner:before,\n    .list:not(.media-list) .accordion-item:not(.media-item)>.item-link .item-inner:before,\n    .media-list .accordion-item .accordion-item-toggle .item-title-row:before,\n    .media-list .accordion-item>.item-link .item-title-row:before,\n    .accordion-item.media-item .accordion-item-toggle .item-title-row:before,\n    .accordion-item.media-item>.item-link .item-title-row:before,\n    .links-list .accordion-item>a:before {\n      content: "chevron_right";\n      width: 14px;\n      height: 8px;\n      margin-top: -4px;\n      line-height: 8px;\n    }\n\n    .list .accordion-item-toggle.accordion-item-opened .item-inner:before,\n    .list:not(.media-list) .accordion-item-opened:not(.media-item) .accordion-item-toggle .item-inner:before,\n    .list:not(.media-list) .accordion-item-opened:not(.media-item)>.item-link .item-inner:before,\n    .media-list .accordion-item-opened .accordion-item-toggle .item-title-row:before,\n    .media-list .accordion-item-opened>.item-link .item-title-row:before,\n    .accordion-item-opened.media-item .accordion-item-toggle .item-title-row:before,\n    .accordion-item-opened.media-item>.item-link .item-title-row:before,\n    .links-list .accordion-item-opened>a:before {\n      content: "chevron_up";\n      width: 14px;\n      height: 8px;\n      margin-top: -4px;\n      line-height: 8px;\n    }\n\n    .circle {\n      background: white;\n      border-radius: 50%;\n      width: 4rem;\n      height: 4rem;\n      top: calc(48% - 2rem);\n      position: relative;\n      left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));\n    }\n\n    .pagemenu {\n      background-color: white;\n      color: black;\n    }\n\n    .homeicon {\n      color: rgba(1, 151, 238, 0.952);\n      position: relative;\n      top: 5px;\n      left: -2px;\n    }\n\n    .pagemenu .list {\n      margin: 0;\n    }\n\n    .pagemenu li {\n      border-bottom: 1px rgb(204, 204, 204) solid;\n    }\n\n    .pagemenu li::after {\n      content: none;\n    }\n\n    .dialogcancelbtn {\n      color: #eb4d3d;\n    }\n\n    .logoutbtn {\n      color: #3478f6;\n    }</style>';
      return r;
    }(this);
  },

  style: `
    .hide-me {
      display: none !important;
    }

    .cant-touch-this {
      pointer-events: none;
    }

    .UserInitIm2 {
      width: 4rem;
      height: 4rem;
      top: calc(48% - 2rem);
      border-radius: 50%;
      background: white;
      font-size: 30px;
      color: black;
      text-align: center;
      line-height: 4rem;
      text-transform: uppercase;

      position: relative;
      left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
      margin-bottom: 60px;
    }

    .header {
      background-color: #4971d9;
      height: 180px;
    }

    .whtxt {
      color: white;
      position: relative;
      margin-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
    }

    .setticon {
      position: absolute;
      top: 52px;
      /* right: 6px; */
      color: white;
      right: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
    }

    .logoclass {
      height: 2rem;
      width: auto;
      padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
      margin-top: 20px;
    }

    .list .accordion-item-toggle .item-inner:before,
    .list:not(.media-list) .accordion-item:not(.media-item) .accordion-item-toggle .item-inner:before,
    .list:not(.media-list) .accordion-item:not(.media-item)>.item-link .item-inner:before,
    .media-list .accordion-item .accordion-item-toggle .item-title-row:before,
    .media-list .accordion-item>.item-link .item-title-row:before,
    .accordion-item.media-item .accordion-item-toggle .item-title-row:before,
    .accordion-item.media-item>.item-link .item-title-row:before,
    .links-list .accordion-item>a:before {
      content: "chevron_right";
      width: 14px;
      height: 8px;
      margin-top: -4px;
      line-height: 8px;
    }

    .list .accordion-item-toggle.accordion-item-opened .item-inner:before,
    .list:not(.media-list) .accordion-item-opened:not(.media-item) .accordion-item-toggle .item-inner:before,
    .list:not(.media-list) .accordion-item-opened:not(.media-item)>.item-link .item-inner:before,
    .media-list .accordion-item-opened .accordion-item-toggle .item-title-row:before,
    .media-list .accordion-item-opened>.item-link .item-title-row:before,
    .accordion-item-opened.media-item .accordion-item-toggle .item-title-row:before,
    .accordion-item-opened.media-item>.item-link .item-title-row:before,
    .links-list .accordion-item-opened>a:before {
      content: "chevron_up";
      width: 14px;
      height: 8px;
      margin-top: -4px;
      line-height: 8px;
    }

    .circle {
      background: white;
      border-radius: 50%;
      width: 4rem;
      height: 4rem;
      top: calc(48% - 2rem);
      position: relative;
      left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));
    }

    .pagemenu {
      background-color: white;
      color: black;
    }

    .homeicon {
      color: rgba(1, 151, 238, 0.952);
      position: relative;
      top: 5px;
      left: -2px;
    }

    .pagemenu .list {
      margin: 0;
    }

    .pagemenu li {
      border-bottom: 1px rgb(204, 204, 204) solid;
    }

    .pagemenu li::after {
      content: none;
    }

    .dialogcancelbtn {
      color: #eb4d3d;
    }

    .logoutbtn {
      color: #3478f6;
    }
  `,
  styleScoped: false
};
    